package org.catharsis.spendtel.core.firebase

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize

object FirebaseWebConfig {
    // Register a Web app in Firebase Console -> Project settings -> Your apps,
    // then replace these values with the firebaseConfig snippet for that app.
    const val API_KEY = "AIzaSyDCckp1vLzXEn7xwELwnxOvrwFzFeIBkEg"
    const val AUTH_DOMAIN = "spendtel.firebaseapp.com"
    const val PROJECT_ID = "spendtel"
    const val STORAGE_BUCKET = "spendtel.firebasestorage.app"
    const val MESSAGING_SENDER_ID = "897226453555"
    const val APP_ID = "1:897226453555:web:387cdfda720ba6a48ae946"
    const val MEASUREMENT_ID = "G-P7LVNSBQRR"
}

fun initializeWebFirebase() {
    Firebase.initialize(
        options = FirebaseOptions(
            apiKey = FirebaseWebConfig.API_KEY,
            authDomain = FirebaseWebConfig.AUTH_DOMAIN,
            projectId = FirebaseWebConfig.PROJECT_ID,
            storageBucket = FirebaseWebConfig.STORAGE_BUCKET,
            gcmSenderId = FirebaseWebConfig.MESSAGING_SENDER_ID,
            applicationId = FirebaseWebConfig.APP_ID,
        ),
    )
}
